import type { InventoryListByIdAPI } from '@openx/types/inventoryList.ts';
import type { RowActionProps, TableColumn } from '@openx/types/tableHelpers.ts';
import { useGetListTableColumns } from './useGetListTableColumns.tsx';
import { useInventoryListsRowActions } from './useInventoryListsRowActions.ts';

type UseInventoryListsTableConfigProps = (searchPhrase: string) => {
  columns: TableColumn<InventoryListByIdAPI>[];
  rowActions: RowActionProps<InventoryListByIdAPI>[];
};

export const useInventoryListsTableConfig: UseInventoryListsTableConfigProps = searchPhrase => {
  const rowActions = useInventoryListsRowActions();
  const tableColumns = useGetListTableColumns(searchPhrase);

  return {
    columns: tableColumns,
    rowActions,
  };
};
